import React, { useState, useEffect } from "react";
import axiosInstance from "../components/ReusableComponents/Axios";
import InternetChecking from "../components/Student/Reusablecomponents/Network";
import DataTable from "../components/Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../components/Student/Reusablecomponents/Loading";
import { FaAnglesLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import DropdownValues from "../components/Student/Reusablecomponents/DropDownValues";
import { useSelector } from "react-redux";
const StudentReports = () => {
    const navigate = useNavigate();
    const [PTR, SetPTR] = useState([]);
    const [Load, SetLoad] = useState(false);
    const [SSubject, SetSSubject] = useState(1);

    const Columns = [
        { name: "Email", selector: "email", sortable: true, },
        { name: "Grade", selector: "grade", sortable: true, },
        { name: "Subject", selector: "subjectName", sortable: true, },
        ...(SSubject != 3 ? [{ name: "Topic", selector: "topicName", sortable: true, }] : []),
        ...(SSubject === 3 ? [
            { name: "Book", selector: "bookName", sortable: true, },
            { name: "Main Reading", selector: "mainreadingpoemName", sortable: true, },
            { name: "Poem", selector: "poemName", sortable: true, },
            { name: "Non-Detailed Lesson", selector: "nonDetailedLessonName", sortable: true, },
            { name: "Grammar", selector: "grammerName", sortable: true, },
        ] : []),

        { name: "No.of Questions", selector: "noofquestions", sortable: true, },
        { name: "Correct Answers", selector: "correctAnswers", sortable: true, },
        { name: "Attempted date time", selector: "attendedDate", sortable: true, },
        { name: "Attempt No", selector: "attemptNo", sortable: true, },
    ];
    // const Userdetail = JSON.parse(localStorage.getItem("EmailId"));
      const Logindetails = useSelector((state) => state.userDetailsData.LoginDetails);
    const GetParticipationDetails = async () => {
        SetLoad((prev) => !prev);
        try {
            const res = await axiosInstance.get(`/PracticeTests/GetPracticeTestTrackforstudent?Email=${Logindetails?.LoginId}&SubjectId=${SSubject}`);
            SetPTR(res.data);
            SetLoad((prev) => !prev);
        }
        catch (err) { console.log(err); }
    }
    useEffect(() => { GetParticipationDetails(); }, [SSubject])
    const Subjects = [
        { display: "Mathematics", value: 1 },
        { display: "Science", value: 2 },
        { display: "English", value: 3 },
        // { display: "Hindi", value: 4, Icon: <RiTranslate /> },
        // { display: "Telugu", value: 5, Icon: <MdOutlineLanguage /> },
    ];
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="dflex alignitems JSBetween">
                    <button className="BackNavigation Buttons" onClick={() => navigate(-1)}> <FaAnglesLeft /> Back</button>
                    <div className="MainHeading"> Practice Test tracking</div>
                    <DropdownValues className="NCLDropdown" options={Subjects} onChange={(e) => SetSSubject(parseInt(e.target.value))} />
                </div>
                <DataTable className="NCLDataTable Card mt-3" data={PTR} columns={Columns} ShowPagination={true}
                    ShowPagecount={true} Dropdownvalues={[10, 25, 50, 100]} />
            </div>
            {Load && <Loading />}
        </>
    )
}
export default StudentReports;